import React from "react";

interface WelcomePointsModalProps {
  action?: "link" | "button";
  onDismiss?: () => void;
}

const WelcomePointsModal = ({ action = "link", onDismiss }: WelcomePointsModalProps) => (
  <div className="arena-home__modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="welcome-title">
    <section className="arena-home__modal">
      <p className="arena-home__eyebrow">STEP 3 / 3</p>
      <h2 id="welcome-title">
        Welcome, <span>Champion</span>
      </h2>
      <div className="arena-home__loot" aria-label="Your loot: 10,000 points">
        <strong>10,000</strong>
        <span>Points</span>
      </div>
      <p>Bet your points on battles. If your champion wins, you recover the opposing pool pro rata to your share.</p>
      <div className="arena-home__modal-actions">
        {action === "button" ? (
          <button className="arena-home__primary" type="button" onClick={onDismiss}>
            Let&apos;s Go
          </button>
        ) : (
          <a className="arena-home__primary" href="/dashboard">
            Let&apos;s Go
          </a>
        )}
      </div>
      <div className="arena-home__dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    </section>
  </div>
);

export default WelcomePointsModal;
